import React from 'react';
import { Link } from 'react-router-dom';

import queryString from 'query-string';

import validator from 'validator';

import {
    Popup, EditableComponent, Loading, InputField,
} from 'arteia-js/components';
import { API } from 'arteia-js/services';

class Login extends EditableComponent {
    state = {
        email: '',
        password: '',

        loginSuccessful: false,
        loginErrored: false,
        loading: false,

        errorCode: null,
        errorMessage: '',
        visible: true,

        redirectUrl: null,
    };

    ERROR_MESSAGES = {
        401: 'Email or password is not correct',
        500: 'Something went wrong',
    };

    componentDidMount() {
        const { history } = this.props;
        const { state } = history.location;

        if (!!state && !!state.errorMessage) {
            this.setState({
                errorMessage: state.errorMessage,
            });
        }
    }


    login = () => {
        const { email, password } = this.state;
        this.setState({ loading: true });

        const { history } = this.props;
        const { returnTo = 'client', openCollection } = queryString.parse(history.location.search);

        API.post('/login', {
            email,
            password,
        }).then((res) => {
            const {
                settingPassword = false, twoFactorRequired = false, changePasswordId, twoFactorId, secureUrl,
            } = res;

            if (settingPassword === true) {
                this.setState({
                    loading: false,
                    visible: false,
                    errorCode: null,
                });
                return history.push(`/password/update/${changePasswordId}`);
            }

            if (twoFactorRequired === true) {
                this.setState({
                    loading: false,
                    visible: false,
                    errorCode: null,
                });
                return history.push('/twoFactor', { twoFactorId, returnTo });
            }

            const query = {
                token: res.token,
                returnTo,
                openCollection,
            };

            this.setState({
                status: 200,
                errorCode: null,
            });
            return window.location.assign(`${secureUrl}/redirect?${queryString.stringify(query)}`);
        }).catch((e) => {
            const { status } = e;
            this.setState({
                loading: false,
                loginErrored: true,
                errorCode: status,
                status,
                errorMessage: this.ERROR_MESSAGES[status] || this.ERROR_MESSAGES[500],
            });
        });
    }


    isDataCorrect = () => {
        const { email, password } = this.state;
        return validator.isEmail(email) && !validator.isEmpty(password);
    };

    handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            this.login();
        }
    };

    render() {
        const {
            email,
            password,
            loading,
            errorMessage,
            status,
            visible,
        } = this.state;

        return (
            <Popup size='form' noTitle
                noCloseHandler
                className="form login-form"
                loading={loading}
                visible={visible}
                loadingComponent={<Loading/>}>
                <div className="popup-content">
                    <h1>Login to your account</h1>
                    <InputField
                        type={'email'}
                        value={email}
                        label={'Email'}
                        onChange={this.onFieldChange('email')}
                    />
                    <InputField
                        type={'password'}
                        value={password}
                        label={'Password'}
                        onChange={this.onFieldChange('password')}
                        handleKeyPress={this.handleKeyPress}
                    />
                    <div className="form-msg">
                        <span className="error-msg">{status !== 200 && errorMessage}</span>
                    </div>
                    <button className='art-btn' disabled={!this.isDataCorrect() || status === 200}
                        onClick={this.login}>
                        Login
                    </button>
                    <Link className="secondary-link" to="/forgot-password">Forgot password?</Link>
                </div>

            </Popup>
        );
    }
}

Login.propTypes = {};
Login.defaultProps = {};

export default Login;



// WEBPACK FOOTER //
// ./src/scenes/Login/index.js